var map = {
	"./hero/avatar.svg": "f9a3",
	"./hero/carousel1.jpeg": "1899",
	"./hero/chuttersnap-6xB6mxsLTV0-unsplash.jpg": "68a8",
	"./hero/contacts1.jpeg": "45c9",
	"./hero/corona1.jpeg": "3e9d",
	"./hero/corona2.jpeg": "bfc6",
	"./hero/dental1.jpeg": "5a3e",
	"./hero/dental2.jpeg": "0c86",
	"./hero/dental3.jpeg": "0d2f",
	"./hero/dental4.jpeg": "09cc",
	"./hero/dental4final.jpeg": "52e4",
	"./hero/doctor.jpg": "3709",
	"./hero/inpatient.jpeg": "a056",
	"./hero/inpatient1.jpeg": "1484",
	"./hero/inpatient2.jpeg": "d875",
	"./hero/lab.jpeg": "bd79",
	"./hero/lab1.jpeg": "a8a8",
	"./hero/lab2.jpeg": "5a40",
	"./hero/lab3.jpeg": "b0b4",
	"./hero/lab4.jpeg": "1844",
	"./hero/landing1.jpeg": "a787",
	"./hero/mart1.jpeg": "a3d4",
	"./hero/mart2.jpeg": "68ca",
	"./hero/mart3.jpeg": "708e",
	"./hero/mart4.jpeg": "916e",
	"./hero/maternal1.jpeg": "fc8f",
	"./hero/maternal2.jpeg": "2246",
	"./hero/maternity.jpeg": "bc28",
	"./hero/maternity3.jpeg": "6417",
	"./hero/maternity3.jpg": "040d",
	"./hero/nhif-guide.jpg": "4888",
	"./hero/nhif-guide.png": "d9a0",
	"./hero/optical1.jpeg": "c678",
	"./hero/optical2.jpeg": "1ec0",
	"./hero/optical3.jpeg": "5844",
	"./hero/optical4.jpeg": "6950",
	"./hero/pharm1.jpeg": "e49f",
	"./hero/pharmacy.jpg": "ca0e",
	"./hero/photo-1519494080410-f9aa76cb4283.jpeg": "bca2",
	"./hero/photo-1614308460927-5024ba2e1dcb.jpeg": "05fb",
	"./hero/physio.jpg": "0db0",
	"./hero/physiotherapy.jpg": "5e19",
	"./hero/test1.jpeg": "e3f9",
	"./hero/test2.jpeg": "ca5b",
	"./hero/test3.jpeg": "40b5",
	"./hero/text4.jpeg": "d42b",
	"./hero/ultra1f.jpeg": "8994",
	"./hero/ultra2.jpeg": "526e",
	"./hero/ultrasound.jpeg": "83b7",
	"./hero/vision.jpg": "6dc4",
	"./insurance/Jubilee.svg": "3d81",
	"./insurance/Saham.svg": "85f5",
	"./insurance/_heritage.jpg": "04a0",
	"./insurance/_madison.png": "c3ed",
	"./insurance/aar.jpeg": "265e",
	"./insurance/ambulance.jpeg": "9923",
	"./insurance/auditor.png": "dc61",
	"./insurance/britam.png": "9ed0",
	"./insurance/carousel2.jpeg": "eb7d",
	"./insurance/cic.png": "9370",
	"./insurance/coop.png": "a1c5",
	"./insurance/ga.png": "7a68",
	"./insurance/kenbright.png": "27f3",
	"./insurance/kenyanalliance.jpg": "6f07",
	"./insurance/laison.png": "bdb8",
	"./insurance/nhif.png": "f33b",
	"./insurance/power.png": "3dea",
	"./insurance/sanlam.png": "e6a8",
	"./insurance/sindano.jpg": "fa04",
	"./services/delivery-bed.jpg": "3765",
	"./services/dental.jpg": "5b39",
	"./services/inpatient.jpg": "6ecf",
	"./services/ultrasound.jpg": "7b1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";